import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./en/translation.json";
import de from "./de/translation.json";
import { getLocalData } from "../utils/localstorage";

const translation = getLocalData("tr") 

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    de: { translation: de },
  },
  lng: translation,
  fallbackLng: "de",
  interpolation: { escapeValue: false },
});

export default i18n;